import React, { Component } from 'react'
import {
    Container,
    Form,
    Button,
    Nav,
    NavItem,
    NavLink
} from 'reactstrap';
import "./review.css"


class review1_0 extends Component {
    render() {
        return (
            <div>
                <Container className="comming">
                <Form className="boxreview">
                        <h1 className="textrandomtest1">Review แบบทดสอบ</h1>
                        <Form className="Q1">
                           <h3 h5 align='center'>คะแนนที่คุณได้</h3>  <br></br>
                           <h1 h5 align='center'>0</h1><br></br>

                           <h5 className="textreview">1. เวลาใดที่กินเวลาน้อยที่สุด </h5><h5 className="textreviewfail">(ท่านตอบข้อนี้ผิด)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก.อดีต</h5>
                           <h5 className="textreviewT">ข.ปัจจุบัน</h5>
                           <h5 className="textreviewF">ค.อนาคต</h5>
                           </Form>

                           <h5 className="textreview">2. ปีปกติสุรทินในระบบสุริยคติมีกี่วัน</h5>  <h5 className="textreviewfail">(ท่านตอบข้อนี้ผิด)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก.354 วัน</h5>
                           <h5 className="textreviewT">ข.365 วัน</h5>
                           <h5 className="textreviewF">ค.366 วัน</h5>
                        </Form>

                        <h5 className="textreview">3. ครึ่งหลังของพุทธศตวรรษที่ 25 หมายถึงช่วงเวลาใด</h5>  <h5 className="textreviewfail">(ท่านตอบข้อนี้ผิด)</h5>
                           <Form className="b1">
                           <h5 className="textreviewT">ก. พ.ศ. 2451–2500</h5>
                           <h5 className="textreviewF">ข. พ.ศ. 2450–2500</h5>
                           <h5 className="textreviewF">ค. พ.ศ. 2550–2600</h5>
                        </Form>

                        <h5 className="textreview">4. ปกติเดือนคี่ทางจันทรคติมีข้างขึ้นและข้างแรมอย่างละกี่วัน</h5>  <h5 className="textreviewfail">(ท่านตอบข้อนี้ผิด)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก. ข้างขึ้น 15 วัน ข้างแรม 15 วัน</h5>
                           <h5 className="textreviewF">ข. ข้างขึ้น 14 วัน ข้างแรม 14 วัน</h5>
                           <h5 className="textreviewT">ค. ข้างขึ้น 15 วัน ข้างแรม 14 วัน</h5>
                        </Form>

                        <h5 className="textreview">5. เราจะใช้วิธีการทางประวัติศาสตร์เมื่อจะศึกษาเรื่องที่มีลักษณะตามข้อใด</h5>  <h5 className="textreviewfail">(ท่านตอบข้อนี้ผิด)</h5>
                           <Form className="b1">
                           <h5 className="textreviewF">ก. เรื่องที่สังคมมักให้ความสนใจ</h5>
                           <h5 className="textreviewT">ข. เรื่องที่อยู่ในความสงสัยของเรา</h5>
                           <h5 className="textreviewF">ค. เรื่องที่มีหลักฐานสืบค้นได้ง่าย</h5>
                        </Form>
                           
                           <p  h5 align='center'><Button href='/randomtest' color="#4fc3f7 light-blue lighten-2" >กลับหน้าหลัก</Button>{' '}</p>
                        </Form>
                       
                </Form>
                </Container>
               
                <div className="footer text-footer">
                    <p>Surasak   Noorurk</p>
                    <p> Project 5935512072 Computer Engineering</p>
                    <NavLink href="https://www.facebook.com/few.connectfve">ช่องทางการติดต่อ</NavLink>
                       
                </div>

            </div> 
        )
    }
}

export default review1_0